<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div class="leftside-menu mt-0">
    <div class="text-center mt-3">
      <img :src="JciLogo" alt="jci-logo" height="54" />
    </div>
    <!-- Sidebar -left -->
    <div class="h-100" id="leftside-menu-container" data-simplebar>
      <menu-lists :dialog="dialog" @hideMenuDialog="hideMenuDialog" />
    </div>
  </div>
  <!-- ========== Left Sidebar End ========== -->
</template>

<script>
import MenuLists from "@/components/MenuLists.vue";
import companyConfig from "@/company_config.json";

export default {
  components: {
    MenuLists,
  },
  data() {
    return {
      dialog: false,
      FounderImage: "",
      JciLogo: "",
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var server_url = companyConfig.apiURL;
      console.log({ server_url });

      var jci_logo = server_url + "assets/images/logo.png";
      console.log({ jci_logo });

      this.JciLogo = jci_logo;
    },
    hideMenuDialog(flag) {
      console.log("hideMenuDialog called");
      console.log({ flag });
      this.dialog = flag;
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.leftside-menu {
  h6 {
    color: white;
  }
}
</style>
